module.exports = __webpack_public_path__ + "5eaa382b48098070f73060d29df1079d.png";